import React, { useState, useEffect } from "react";
// import { ThemeProvider } from "@mui/material/styles";
// import { Input } from "mdb-ui-kit"; // module
import "mdb-ui-kit/css/mdb.min.css";

import "./Styles/BranchForm.css";
import axios from "axios";
import ApiSettings from "../../../../../Settings/ApiSettings.json";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Cookies from "universal-cookie";
const cookies = new Cookies();
// export interface State extends SnackbarOrigin {
//   open: boolean;
// }
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function UpdateBranchForm(props) {
  const [object, setObject] = useState({
    name: props.object.name,
    id: props.object.id,
  });
  const [loading, setLoading] = useState(false);
  const [showBoxOfVarietiesList, setshowBoxOfVarietiesList] = useState(false);
  useEffect(() => {
    if (!cookies.get("role_id")) {
      window.location.href = "/";
    }
  }, []);

  const [dataOFVarieties, setdataOFVarieties] = useState([]);

  //   const [openSnackbar, setopenSnackbar] = useState(false);
  const [snackBar, setsnackBar] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
    message: "",
    severity: "",
  });
  const { vertical, horizontal, open } = snackBar;

  //get data of varieties Carrier ....
  const getDataOfBranch = async (IpAddress) => {
    let data = null;
    try {
      data = await axios({
        method: "get",
        url: IpAddress + "/branches_list",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization":'ar'
        },
      });

      if (data) {
        if (data.status == 200) {
          setdataOFVarieties(data.data);
        }
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "warning",
        open: true,
      });
    }
  };
  useEffect(() => {
    setObject(props.object);
    getDataOfBranch(ApiSettings.apiUrl);
  }, [props.object]);

  //here we will sent request with data to save it in our database.
  const sentFormData = async () => {
    if (!object.name) {
      //   alert("أسم الفرع مطلوب");
      setsnackBar({
        ...snackBar,
        message: "أسم الفرع مطلوب",
        severity: "warning",
        open: true,
      });
      return;
    }
    setLoading(true);

    let data = null;
    try {
      data = await axios({
        method: "put",
        url: ApiSettings.apiUrl + "/branches/"+object.id,
        data: {
          name: object.name,
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-localization":'ar'
        },
      });

      console.log("update",data);
      if (data) {
        if (data.data.status == 200) {
          setLoading(false);
          setdataOFVarieties((item) => [...item, data.data.data]);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "success",
            open: true,
          });
          props.setReloadData()
        } else if (data.data.status == 402) {
          //   alert(data.data.data.name);
          setsnackBar({
            ...snackBar,
            message: data.data.data.name,
            severity: "warning",
            open: true,
          });
        } else {
          //   alert(data.data.message);
          setsnackBar({
            ...snackBar,
            message: data.data.message,
            severity: "warning",
            open: true,
          });
        }
        setLoading(false);
      }
    } catch (err) {
      //   alert(err.message);
      setsnackBar({
        ...snackBar,
        message: err.message,
        severity: "error",
        open: true,
      });
      setLoading(false);
    }
  };

  //handle open snackbar ....
  const handleClick = () => {
    setsnackBar({ open: true, ...snackBar });
  };
  //handle clode snackbar
  const handleClose = () => {
    setsnackBar({ ...snackBar, open: false });
  };

  return (
    <div
      className={`ModalFormContainer rounded-3 px-2 ${
        props.inactive === false ? "activeSideMenu" : ""
      }`}
    >
      {/* header of form section  */}
      <div className="container-lg py-4 px-2 ">
        <div className="row">
          <div className="col-md-12 ">
            <div className="toSection d-flex justify-content-center align-items-center">
              <span className="FormName">تعد يل فرع</span>
            </div>
          </div>
        </div>
      </div>

      {/* section1 here...  */}
      <div className="section1 container-lg py-4 px-2 pe-4">
        <div className="row">
          <div className="col-md-12 align-items-center  d-flex">
            <div
              className="form-outline formInput"
              style={{ position: "relative" }}
            >
              <label
                // className="form-label"
                htmlFor="lableforTypeOFActivity"
                className="lableforTypeOFActivity"
              >
                أسم الفرع
              </label>
              <input
                type="text"
                id="lableforTypeOFActivity"
                className="TypeOFActivity"
                placeholder="أسم الفرع..."
                value={object.name}
                onChange={(e) => {
                  setObject({
                    ...object,
                    name: e.target.value,
                  });
                }}
                onClick={() => {
                  setshowBoxOfVarietiesList(!showBoxOfVarietiesList);
                }}
              />
              {showBoxOfVarietiesList ? (
                <div className="dropdownlistselected">
                  {dataOFVarieties.length > 0 ? (
                    dataOFVarieties.map((data) => (
                      <span className="itemOfList">{data.name}</span>
                    ))
                  ) : (
                    <span className="px-3">لاتوجد بيانات</span>
                  )}
                </div>
              ) : null}
            </div>

            <div className="d-flex align-items-center mt-3">
              <Button
                variant="contained"
                className="mx-3 section1CarrerName section1Button mt-4 pt-1"
                onClick={() => {
                  sentFormData();
                }}
              >
                {!loading ? (
                  "تعديل"
                ) : (
                  <div className="spinner-border " role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
      {/* snack alert box here ... */}
      <Snackbar
        open={snackBar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          onClose={handleClose}
          severity={snackBar.severity}
          sx={{ width: "100%" }}
        >
          {snackBar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
